import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyPhone as SchemaCompanyPhone } from '../schemas/CompanyPhone';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyPhonesContentType = '' as const;
export type GetCompanyPhonesRequest = void;
export type GetCompanyPhonesResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company phones
     */
    '200': {
        'application/json': SchemaCompanyPhone[];
    };
};
export type GetCompanyPhonesResponseSuccess = GetCompanyPhonesResponses['200']['application/json'];
export type GetCompanyPhonesSearchParams = undefined;
export type GetCompanyPhonesPathParameters = undefined;
export const GetCompanyPhonesUrl = '/company/phones' as const;
export const GetCompanyPhonesMethod = 'GET' as const;
export const getGetCompanyPhonesUrl = (_params?: GetCompanyPhonesPathParameters) => GetCompanyPhonesUrl;
